import MUISnackbar from '@mui/material/Snackbar'

export const Snackbar = MUISnackbar
